document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".cart-line__qty").forEach(function (input) {
    input.addEventListener("change", function () {
      if (Number(input.value) < 0) input.value = 0;
    });
  });

  var main = document.getElementById("GalleryMain");
  document.querySelectorAll(".gallery__thumb").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!main) return;
      main.removeAttribute("srcset");
      main.src = thumb.dataset.full;
      document.querySelectorAll(".gallery__thumb").forEach(function (t) {
        t.classList.toggle("is-active", t === thumb);
      });
    });
  });
});
